import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable } from 'knockout';
import events from 'managers/events';
import WCCEntity from 'models/entity';
import './base.html';
import './base.scss';

export interface CommunityWidgetVMConfig {
    Demo?: boolean

    demo?: boolean
}

export class CommunityWidgetModel<T extends CommunityWidgetVMConfig = CommunityWidgetVMConfig> extends WCCEntity<T> {
    demo: Subscribable<boolean>

    constructor(data?: T) {       
        super();

        if (data != undefined)
            this.normalizeData(data);

        this.demo = ko.flattenComputed(data?.demo, settings.demoWidgets);
    }

    protected normalizeData(data: T) {
        data.demo ??= data.Demo;
    }
}

@injectable()
export default class CommunityWidgetVM<T extends CommunityWidgetModel = CommunityWidgetModel> {
    demo: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) public model: T,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.demo = model.demo;

        ko.applyBindingsToNode(info.element, {
            'css': {
                'wcc-widget': true
            }
        });
    }

    getTemplateNodes(): Array<Node> {
        return [];
    }

    protected onChange() {
        events.communityWidgetSettingsAreChanged.trigger(this.model);
    }

    protected onSettingsShown() {
        events.communityWidgetSettingsAreShown.trigger(this.model);
    }

    protected onSettingsHidden() {
        events.communityWidgetSettingsAreHidden.trigger(this.model);
    }
}